// getNotiStatus.ts

import {
    MiniKit,
    // type GetPermissionsPayload,
    // type Permission,
} from "@worldcoin/minikit-js";

export const getPermissionStatuses = async () => {
    try {
        const payload = await MiniKit.getPermissions();
        console.log("payload", payload);
        if (payload.data.status !== "success") {
            throw new Error("getPermissions returned an error payload");
        }
        const permissions = payload.data.permissions;

        // NOTIS
        let notiStatus: boolean = false;
        if (permissions.notifications) {
            notiStatus = permissions.notifications;
        } else if (permissions.notifications === "sent") {
            notiStatus = true;
        }

        // const notiStatus: boolean = permissions.notifications ?? false;
        const contactsStatus: boolean = permissions.contacts ?? false;
        const microphoneStatus: boolean = permissions.microphone ?? false;
        console.log("notiStatus", notiStatus);
        console.log("contactsStatus", contactsStatus);
        return { notiStatus, contactsStatus, microphoneStatus };
    } catch (err) {
        console.error("getPermissions failed", err);
    }

    return {
        notiStatus: false,
        contactsStatus: false,
        microphoneStatus: false,
    };
};
